import { IState } from 'legacy/lut/store'

export const selectStrategicInitiativesState = (state: IState) =>
  state.partner360.strategicInitiatives
